
import PropTypes from 'prop-types'
import { Card, CardContent, Grid, Typography } from '@mui/material'
import NotFoundImage from 'frame/assets/404.png'

const NoDataView = ({ errorMessage, agreementNo }) => {

  return (
    <Card>
      <CardContent
        sx={{
          textAlign: 'center',
          paddingY: 3,
          paddingX: 1.2,
          '@media (min-width: 600px)': {
            padding: 3,
          },
        }}>
        <Typography gutterBottom variant="h4">
          Error
        </Typography>

        <div
          style={{
            height: '200px',
            marginTop: '24px',
          }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <img
                style={{
                  justifySelf: 'center',
                  width: '200px',
                  height: 'auto',
                }}
                src={NotFoundImage}
                alt=""/>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">
                {errorMessage
                  ? `Error: ${errorMessage} for vehicle registration ${agreementNo}`
                  : agreementNo
                    ? `No data for vehicle registration ${agreementNo}`
                    : 'No Data'}
              </Typography>
            </Grid>
          </Grid>
        </div>
      </CardContent>
    </Card>
  )
}

NoDataView.propTypes = {
  errorMessage: PropTypes.string,
  agreementNo: PropTypes.string,
}

export default NoDataView
